import React from 'react';
import { Form, Tabs } from 'antd';
import InvoiceItemsTable from './InvoiceItemsTable';
import InvoiceVouchers from './InvoiceVouchers';
import InvoiceTotals from './InvoiceTotals';

const InvoiceModalBody = ({
  form,
  mode,
  isSale,
  activeTabKey,
  onTabChange,
  materials,
  saleMaterials,
  currencies,
  factors,
  materialPrices,
  onFetchMaterials,
  onFetchSaleMaterials,
  onAddMaterial,
  onCreatePurchase,
}) => (
  <Tabs activeKey={activeTabKey} onChange={onTabChange}>
    <Tabs.TabPane tab="المواد" key="items">
      <div style={{ minHeight: '18vh', maxHeight: '20vh', overflowY: 'auto', overflowX: 'hidden' }}>
        <Form.List name="Items">
          {(fields, { add, remove }) => (
            <InvoiceItemsTable
              form={form}
              mode={mode}
              isSale={isSale}
              materials={materials}
              saleMaterials={saleMaterials}
              currencies={currencies}
              factors={factors}
              materialPrices={materialPrices}
              onFetchMaterials={onFetchMaterials}
              onFetchSaleMaterials={onFetchSaleMaterials}
              onAddMaterial={onAddMaterial}
              onCreatePurchase={onCreatePurchase}
              fields={fields}
              remove={remove}
              add={add}
            />
          )}
        </Form.List>
      </div>

      <InvoiceTotals form={form} factors={factors} />
    </Tabs.TabPane>

    <Tabs.TabPane tab="الدفعات" key="vouchers">
      <InvoiceVouchers currencies={currencies} form={form} />
    </Tabs.TabPane>
  </Tabs>
);

export default InvoiceModalBody;
